// apps/web/src/routes/job-tracker.tsx
import { createFileRoute, redirect } from "@tanstack/react-router";

import { PageLayout } from "@/components/page-layout";
import { TrackerList } from "@/components/tracker-list";
import { getUser } from "@/functions/get-user";
import { seo } from "@/utils/seo";

export const Route = createFileRoute("/job-tracker")({
  beforeLoad: async () => {
    const session = await getUser();
    if (!session) {
      throw redirect({ to: "/" });
    }
    return { session };
  },
  head: () =>
    seo({
      title: "Application Tracker — Kanban Job Pipeline | JobCues",
      description:
        "Track job applications, interview stages, offers, and attached tailored resumes in a unified Kanban pipeline.",
      path: "/job-tracker",
      noindex: true,
    }),
  component: TrackerComponent,
});

function TrackerComponent() {
  return (
    <PageLayout id="tracker-content">
      <TrackerList />
    </PageLayout>
  );
}
